import { PaymentStatus } from '@enums';

export abstract class PaymentUtils {
  public static isPaid(paymentStatus: PaymentStatus): boolean {
    return paymentStatus === PaymentStatus.PAID;
  }

  public static getStatusText(paymentStatus: PaymentStatus): string {
    switch (paymentStatus) {
      case PaymentStatus.PAID:
        return 'Paid';
      case PaymentStatus.PAID_WITH_ERRORS:
        return 'Paid with errors';
      case PaymentStatus.PENDING:
        return 'Payment Pending';
      case PaymentStatus.FAILED:
        return 'Payment Failed';
      default:
        return 'Unknown';
    }
  }
}
